import script from "./TopPanelUserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopPanelUserMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TopPanelUserMenu.vue?vue&type=style&index=0&id=edd49a00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd49a00"]])

export default __exports__